export default {"src":"/_next/static/media/holdMoney_24.e0a44bc4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};